import { createSelector } from 'reselect';
import { initialState } from './reducer';

/**
 * Direct selector to the downloadReport state domain
 */

const selectDownloadReportDomain = state =>
  state.downloadReport || initialState;

/**
 * Other specific selectors
 */

/**
 * Default selector used by DownloadReport
 */

const makeSelectDownloadReport = () =>
  createSelector(
    selectDownloadReportDomain,
    substate => substate,
  );

export default makeSelectDownloadReport;
export { selectDownloadReportDomain };
